
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';
  import {TeamModel} from '@/models/team.model';
  import {bottomVisible} from '@/utils/utils';
  import ListTeamItem from '@/components/Shared/ListTeamItem.vue';

  @Component({
    components: {ListTeamItem}
  })
  export default class ListTeams extends Vue {
    @Prop({required: true}) teams!: TeamModel[];
    @Prop({required: true}) total!: number;
    @Prop({required: false, default: false}) loading!: boolean;

    mounted() {
      window.addEventListener('scroll', () => {
        if (bottomVisible() || this.teams.length < this.total) {
          this.scrollInBottom();
        }
      });
    }

    @Emit()
    scrollInBottom() {
      return;
    }
  }
